"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const messages_center_1 = __importDefault(require("@user-engagement/messages-center"));
const notification_bell_1 = __importDefault(require("@user-engagement/notification-bell"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const Styled = __importStar(require("./styled"));
const MessageAnchor = (aProps) => (0, jsx_runtime_1.jsx)(Styled.Anchor, Object.assign({}, aProps));
const MessageCenterHeaderWidget = ({ pageName, siteId, memberId, path, translations, linkWrapper, isTransparent, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        setIsOpen(true);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setIsOpen(false);
    }, []);
    const LinkWrapper = linkWrapper ? linkWrapper : MessageAnchor;
    return ((0, jsx_runtime_1.jsxs)(Styled.MessageCenterContainer, { onMouseLeave: handleMouseLeave, onMouseEnter: handleMouseEnter, "data-testid": "widget-container", children: [(0, jsx_runtime_1.jsx)(LinkWrapper, { "aria-label": "notifications", href: "/gr/my-notifications", children: (0, jsx_runtime_1.jsxs)(Styled.IconContainer, { "$isTransparent": isTransparent, children: [(0, jsx_runtime_1.jsx)(notification_bell_1.default, { memberId: memberId, siteId: siteId, path: path }), (0, jsx_runtime_1.jsx)(Styled.Title, { children: translations.widgetTitle })] }) }), (0, jsx_runtime_1.jsx)(Styled.ContentMenu, { children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: 200, mountOnEnter: true, unmountOnExit: true, classNames: "header--menu", "data-facil-iti": "header-menu-button", children: (0, jsx_runtime_1.jsx)(Styled.Content, { children: (0, jsx_runtime_1.jsx)(Styled.Scrollable, { children: (0, jsx_runtime_1.jsx)(messages_center_1.default, { isLight: true, pageName: pageName, emptyTitle: translations.emptyTitle, emptySubtitle: translations.emptySubtitle, emptyButtonName: translations.emptyButtonName, errorTitle: translations.errorTitle, errorSubtitle: translations.errorSubtitle, errorRefreshButtonName: translations.errorRefreshButtonName, errorReturnButtonName: translations.errorReturnButtonName, memberId: memberId, siteId: siteId, path: path, linkWrapper: linkWrapper }) }) }) }) })] }));
};
exports.default = MessageCenterHeaderWidget;
